<template>
  <div class="subViewMain">
    <router-view />
  </div>
</template>
 
<script>
export default {
  name: "subViewMain",
  components: {
  }
}
</script>
<style scoped lang="scss">
.subViewMain {
  background: #444444;
  width: 100%;
  height: 100vh;
}
</style>